import { Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import FormLabel from './FormLabel';

function InfoBlock({ label, value }) {
  return (
    <Grid2 container spacing={1}>
      <Grid2 xs={8}>
        <FormLabel>{label}</FormLabel>
      </Grid2>
      <Grid2 xs={4}>
        <Typography
          sx={{ fontSize: '14px', fontWeight: 500, textAlign: 'right' }}>
          {value}
        </Typography>
      </Grid2>
    </Grid2>
  );
}

export default InfoBlock;
